import { withInstall } from '@fx-front-framework/utils/with-install'
import AnimPage from './src/index.vue'

export const FxAnimPage = withInstall(AnimPage)
export default FxAnimPage

